import { createContext, useContext, useMemo, useState } from 'react';
import { applyLanguage, directionOf, formatDateTime, formatMoney, formatNumber, localeOf,
  normalizeLanguage, readLanguage, saveLanguage, translate, translateError } from '../lib/i18n.js';

const LanguageContext = createContext(null);

export default function LanguageProvider({ children }) {
  const [language, updateLanguage] = useState(() => {
    let lang = 'ar';
    try { lang = readLanguage(window.localStorage); } catch { /* التخزين الخاص */ }
    applyLanguage(lang, document);
    return lang;
  });
  const value = useMemo(() => ({
    language, direction: directionOf(language), locale: localeOf(language),
    setLanguage(next) {
      let storage;
      try { storage = window.localStorage; } catch { /* يمكن أن يحجب المتصفح الخاص الخاصية نفسها */ }
      updateLanguage(saveLanguage(normalizeLanguage(next), storage, document));
    },
    t: (key, params) => translate(language, key, params),
    money: (amount) => formatMoney(language, amount),
    number: (amount) => formatNumber(language, amount),
    dateTime: (date) => formatDateTime(language, date),
    errorText: (error) => translateError(language, error),
  }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const value = useContext(LanguageContext);
  if (!value) throw new Error('LanguageProvider is required');
  return value;
}
